import type { Dates, Maybe, Meta, ModelType, Month, Product } from '@/types'
import type { MakeRequired } from '@/types/utilities'

export interface Subscription
  extends Omit<ModelType, 'active' | 'sort'>,
    Dates {
  source: SubscriptionSource
  email: string
  phone: Maybe<string>
  name: Maybe<string>
  product?: Maybe<Product>
}

export type SubscriptionsMeta = MakeRequired<
  Meta<Subscription, SelectedSubscriptionFilters, SelectedSubscriptionOptions>,
  'page' | 'total' | 'limit' | 'sort' | 'filters' | 'options'
>

export interface SelectedSubscriptionFilters {
  hasSource?: SubscriptionSource
  hasEmail?: Maybe<string>
  fromYear?: Maybe<number>
  fromMonth?: Maybe<Month>
  fromDay?: Maybe<number>
  hasNonEmptyEmail?: boolean
}

export interface SelectedSubscriptionOptions {
  years?: number[]
}

export enum SubscriptionSource {
  Footer = 'footer',
  Popup = 'popup',
  Order = 'order',
  Product = 'product',
  Loyalty = 'loyalty',
}
